var map = {
	"./ABAColor.png": 8391,
	"./COPLAFT2024.png": 9475,
	"./CongresoImage.png": 703,
	"./LogoABA.png": 1659,
	"./Sello_ABA.png": 1958,
	"./SignGT.png": 8294,
	"./SignRR.png": 651,
	"./Sold out.png": 6438,
	"./capacitaciones.png": 4919,
	"./felabaLogo.png": 3984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2183;